import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import ActionLoader from 'Modules/Shared/components/ActionsRouteLoader';
import Error from './js/modules/Error/containers/ModuleRoot/index.js';
import Reconnect from './js/modules/Reconnect/containers/ModuleRoot/index.js';
import RefreshSalesforceMeta from 'Modules/Shared/components/RefreshSalesforceMeta';
import Salesnavconnected from './js/modules/SalesNavigatorConnected/ModuleRoot.tsx';
import NotFound from './js/modules/NotFound/containers/ModuleRoot/index.js';

const HomeLazyLoad = lazy(() =>
  import(
    /* webpackChunkName: 'home' */ './js/modules/Home/containers/ModuleRoot/index.js'
  )
);
const Home = () => {
  return (
    <Suspense fallback={<ActionLoader />}>
      <HomeLazyLoad />
    </Suspense>
  );
};

const ActionsWrapperlazyLoad = lazy(() =>
  import(
    /* webpackChunkName: 'actionsWrapper' */ './js/modules/Actions/containers/ActionsWrapper/index.js'
  )
);
const ActionsWrapper = () => {
  return (
    <Suspense fallback={<ActionLoader />}>
      <ActionsWrapperlazyLoad />
    </Suspense>
  );
};

const ActionslazyLoad = lazy(() =>
  import(
    /* webpackChunkName: 'actions' */ './js/modules/Actions/containers/ModuleRoot/index.js'
  )
);
const Actions = () => {
  return (
    <Suspense fallback={<ActionLoader />}>
      <ActionslazyLoad />
    </Suspense>
  );
};

const ActionComposelazyLoad = lazy(() =>
  import(
    /* webpackChunkName: 'actionCompose' */ './js/modules/ActionCompose/containers/ModuleRoot/index.js'
  )
);

const ActionCompose = () => {
  return (
    <Suspense fallback={<ActionLoader />}>
      <ActionComposelazyLoad />
    </Suspense>
  );
};

const EmailsLazyLoad = lazy(() =>
  import(
    /* webpackChunkName: 'emails' */ './js/modules/Emails/containers/ModuleRoot/index.js'
  )
);
const Emails = () => {
  return (
    <Suspense fallback={<ActionLoader />}>
      <EmailsLazyLoad />
    </Suspense>
  );
};

const ActivityLogLazyLoad = lazy(() =>
  import(
    /* webpackChunkName: 'activityLog' */ './js/modules/ActivityLog/containers/ModuleRoot/index.js'
  )
);
const ActivityLog = () => {
  return (
    <Suspense fallback={<ActionLoader />}>
      <ActivityLogLazyLoad />
    </Suspense>
  );
};

const FlowsLazyLoad = lazy(() =>
  import(
    /* webpackChunkName: 'flows' */ './js/modules/Flows/containers/ModuleRoot/index.js'
  )
);
const Flows = () => {
  return (
    <Suspense fallback={() => <div />}>
      <FlowsLazyLoad />
    </Suspense>
  );
};

const FlowsWrapperLazyLoad = lazy(() =>
  import(
    /* webpackChunkName: 'flowsWrapper' */ './js/modules/Flows/containers/FlowsWrapper/index.js'
  )
);
const FlowsWrapper = () => {
  return (
    <Suspense fallback={() => <div />}>
      <FlowsWrapperLazyLoad />
    </Suspense>
  );
};

const FlowsWizardLazyLoad = lazy(() =>
  import(
    /* webpackChunkName: 'flowsWizard' */ './js/modules/FlowsWizard/containers/ModuleRoot/index.js'
  )
);
const FlowsWizard = () => {
  return (
    <Suspense fallback={<ActionLoader />}>
      <FlowsWizardLazyLoad />
    </Suspense>
  );
};

const FlowsShowLazyLoad = lazy(() =>
  import(
    /* webpackChunkName: 'flowsShow' */ './js/modules/FlowsShow/containers/ModuleRoot/index.js'
  )
);
const FlowsShow = () => {
  return (
    <Suspense fallback={<ActionLoader />}>
      <FlowsShowLazyLoad />
    </Suspense>
  );
};

const WorkStepLazyLoad = lazy(() =>
  import(
    /* webpackChunkName: 'workStep' */ './js/modules/WorkStep/containers/ModuleRoot/index.js'
  )
);
const WorkStep = () => {
  return (
    <Suspense fallback={<ActionLoader />}>
      <WorkStepLazyLoad />
    </Suspense>
  );
};

const TemplatesLazyLoad = lazy(() =>
  import(
    /* webpackChunkName: 'templates' */ './js/modules/Templates/containers/ModuleRoot/index.js'
  )
);
const Templates = () => {
  return (
    <Suspense fallback={<ActionLoader />}>
      <TemplatesLazyLoad />
    </Suspense>
  );
};

const SharedRecordingLazyLoad = lazy(() =>
  import(
    /* webpackChunkName: 'CISharedRecording' */ './js/modules/Conversations/SharedRecording/SharedRecording.tsx'
  )
);
const SharedRecording = () => {
  return (
    <Suspense fallback={<ActionLoader />}>
      <SharedRecordingLazyLoad />
    </Suspense>
  );
};

const ConversationsWrapperLazyLoad = lazy(() =>
  import(
    /* webpackChunkName: 'conversationsWrapper' */ './js/modules/Conversations/ConversationsWrapper/index.js'
  )
);
const ConversationsWrapper = () => {
  return (
    <Suspense fallback={<ActionLoader />}>
      <ConversationsWrapperLazyLoad />
    </Suspense>
  );
};

const ConversationsLazyLoad = lazy(() =>
  import(
    /* webpackChunkName: 'conversations' */ './js/modules/Conversations/ModuleRoot.tsx'
  )
);
const Conversations = () => {
  return (
    <Suspense fallback={<ActionLoader />}>
      <ConversationsLazyLoad />
    </Suspense>
  );
};

const ConversationsShowLazyLoad = lazy(() =>
  import(
    /* webpackChunkName: 'conversationsShow' */ './js/modules/Conversations/Show/ModuleRoot.tsx'
  )
);
const ConversationsShow = () => {
  return (
    <Suspense fallback={<ActionLoader />}>
      <ConversationsShowLazyLoad />
    </Suspense>
  );
};

const AnalyticsLazyLoad = lazy(() =>
  import(
    /* webpackChunkName: 'analytics' */ './js/modules/Analytics/containers/ModuleRoot/index.js'
  )
);
const Analytics = () => {
  return (
    <Suspense fallback={<ActionLoader />}>
      <AnalyticsLazyLoad />
    </Suspense>
  );
};

const OutcomesLazyLoad = lazy(() =>
  import(
    /* webpackChunkName: "outcomes" */ './js/modules/Outcomes/components/ModuleRoot/index.tsx'
  )
);
const Outcomes = () => {
  return (
    <Suspense fallback={<ActionLoader />}>
      <OutcomesLazyLoad />
    </Suspense>
  );
};

const LightningOutLazy = lazy(() =>
  import(
    /* webpackChunkName: "lightningout" */ './js/modules/LightningOut/components/ModuleRoot/ModuleRoot.tsx'
  )
);
const LightningOut = () => (
  <Suspense fallback={<ActionLoader />}>
    <LightningOutLazy />
  </Suspense>
);

const MobileWysiwygLazy = lazy(() =>
  import(
    /* webpackChunkName: "mobileWysiwyg" */ './js/modules/MobileWysiwyg/components/ModuleRoot/ModuleRoot.tsx'
  )
);
const MobileWysiwyg = () => (
  <Suspense fallback={<ActionLoader />}>
    <MobileWysiwygLazy />
  </Suspense>
);

const PlaysWrapperLazy = lazy(() =>
  import(
    /* webpackChunkName: "playsWrapper" */ './js/modules/Plays/components/PlaysWrapper/index.js'
  )
);
const PlaysWrapper = () => (
  <Suspense fallback={<ActionLoader />}>
    <PlaysWrapperLazy />
  </Suspense>
);

const PlaysLazy = lazy(() =>
  import(
    /* webpackChunkName: "plays" */ './js/modules/Plays/components/ModuleRoot/ModuleRoot.tsx'
  )
);
const Plays = () => (
  <Suspense fallback={<ActionLoader />}>
    <PlaysLazy />
  </Suspense>
);

const PlaysShowLazy = lazy(() =>
  import(
    /* webpackChunkName: "playsShow" */ './js/modules/Plays/show/components/ModuleRoot/ModuleRoot.tsx'
  )
);
const PlaysShow = () => (
  <Suspense fallback={<ActionLoader />}>
    <PlaysShowLazy />
  </Suspense>
);

const PlaysHistoryLazy = lazy(() =>
  import(
    /* webpackChunkName: "playsHistory" */ './js/modules/Plays/history/list/components/ModuleRoot/ModuleRoot.tsx'
  )
);
const PlaysHistory = () => (
  <Suspense fallback={<ActionLoader />}>
    <PlaysHistoryLazy />
  </Suspense>
);

const PlaysHistoryDetailsLazy = lazy(() =>
  import(
    /* webpackChunkName: "playsHistory" */ './js/modules/Plays/history/details/components/ModuleRoot/ModuleRoot.tsx'
  )
);
const PlaysHistoryDetails = () => (
  <Suspense fallback={<ActionLoader />}>
    <PlaysHistoryDetailsLazy />
  </Suspense>
);

const AccountsLazy = lazy(() =>
  import(
    /* webpackChunkName: "accounts" */ './js/modules/Accounts/containers/ModuleRoot/index.js'
  )
);
const Accounts = () => (
  <Suspense fallback={<ActionLoader />}>
    <AccountsLazy />
  </Suspense>
);

const ScheduledEmailsLazy = lazy(() =>
  import(
    /* webpackChunkName: "scheduledEmails" */ './js/modules/ScheduledEmails/containers/ModuleRoot/index.js'
  )
);
const ScheduledEmails = () => (
  <Suspense fallback={<ActionLoader />}>
    <ScheduledEmailsLazy />
  </Suspense>
);

const EmailRemindersLazy = lazy(() =>
  import(
    /* webpackChunkName: "emailReminders" */ './js/modules/EmailReminders/containers/ModuleRoot/index.js'
  )
);

const EmailReminders = () => (
  <Suspense fallback={<ActionLoader />}>
    <EmailRemindersLazy />
  </Suspense>
);

const PeopleLazy = lazy(() =>
  import(
    /* webpackChunkName: "people" */ './js/modules/People/containers/ModuleRoot/index.js'
  )
);

const People = () => (
  <Suspense fallback={<ActionLoader />}>
    <PeopleLazy />
  </Suspense>
);

const SettingsLazy = lazy(() =>
  import(
    /* webpackChunkName: "settings" */ './js/modules/Settings/containers/ModuleRoot/index.js'
  )
);

const Settings = () => (
  <Suspense fallback={<ActionLoader />}>
    <SettingsLazy />
  </Suspense>
);

const SpacesWrapperLazy = lazy(() =>
  import(
    /* webpackChunkName: "spacesIndex" */ './js/modules/Spaces/index/containers/SpacesWrapper/index.js'
  )
);

const SpacesWrapper = () => (
  <Suspense fallback={<ActionLoader />}>
    <SpacesWrapperLazy />
  </Suspense>
);

const SpacesLazy = lazy(() =>
  import(
    /* webpackChunkName: "spacesIndex" */ './js/modules/Spaces/index/containers/ModuleRoot/index.js'
  )
);
const Spaces = () => (
  <Suspense fallback={<ActionLoader />}>
    <SpacesLazy />
  </Suspense>
);

const SpacesShowLazy = lazy(() =>
  import(
    /* webpackChunkName: "spacesShow" */ './js/modules/Spaces/show/containers/ModuleRoot/index.js'
  )
);
const SpacesShow = () => (
  <Suspense fallback={<ActionLoader />}>
    <SpacesShowLazy />
  </Suspense>
);

const CoachingLazy = lazy(() =>
  import(
    /* webpackChunkName: "coaching" */ './js/modules/Coaching/containers/ModuleRoot/index.js'
  )
);
const Coaching = () => (
  <Suspense fallback={<ActionLoader />}>
    <CoachingLazy />
  </Suspense>
);

const TroubleshootingLazy = lazy(() =>
  import(
    /* webpackChunkName: "troubleshooting" */ './js/modules/Troubleshooting/containers/ModuleRoot/index.js'
  )
);
const Troubleshooting = () => (
  <Suspense fallback={<ActionLoader />}>
    <TroubleshootingLazy />
  </Suspense>
);

const OnboardingWrapperLazy = lazy(() =>
  import(
    /* webpackChunkName: "onboardingLanding" */ './js/modules/Onboarding/landing/containers/OnboardingWrapper/index.js'
  )
);
const OnboardingWrapper = () => (
  <Suspense fallback={<ActionLoader />}>
    <OnboardingWrapperLazy />
  </Suspense>
);

const OnboardingLandingLazy = lazy(() =>
  import(
    /* webpackChunkName: "onboardingLanding" */ './js/modules/Onboarding/landing/containers/ModuleRoot/index.js'
  )
);
const OnboardingLanding = () => (
  <Suspense fallback={<ActionLoader />}>
    <OnboardingLandingLazy />
  </Suspense>
);

const OnboardingStepsLazy = lazy(() =>
  import(
    /* webpackChunkName: "onboardingSteps" */ './js/modules/Onboarding/steps/containers/ModuleRoot/index.js'
  )
);
const OnboardingSteps = () => (
  <Suspense fallback={<ActionLoader />}>
    <OnboardingStepsLazy />
  </Suspense>
);

const MicrosoftOnboardingStepsLazy = lazy(() =>
  import(
    /* webpackChunkName: "microsoftOnboardingSteps" */ './js/modules/Onboarding/microsoft_steps/containers/ModuleRoot/index.js'
  )
);
const MicrosoftOnboardingSteps = () => (
  <Suspense fallback={<ActionLoader />}>
    <MicrosoftOnboardingStepsLazy />
  </Suspense>
);

export const AppRoutes = ({ defaultRoute }) => {
  return (
    <>
      <Routes>
        {defaultRoute ? (
          <Route path="/" element={<Settings />} />
        ) : (
          <Route path="/" element={<Home />} />
        )}

        <Route path="actions/*" element={<ActionsWrapper />}>
          <Route index element={<Actions />} />
          <Route path="compose" element={<ActionCompose />} />
        </Route>

        <Route path="emails" element={<Emails />} />
        <Route path="activity-log" element={<ActivityLog />} />

        <Route path="flows/*" element={<FlowsWrapper />}>
          <Route index element={<Flows />} />
          <Route path="wizard" element={<FlowsWizard />} />
          <Route path=":id" element={<FlowsShow />} />
          <Route path=":id/:tabName?" element={<FlowsShow />} />
        </Route>

        <Route path="steps/:id/work" element={<WorkStep />} />
        <Route path="templates" element={<Templates />} />
        <Route path="shared_conversation/:id" element={<SharedRecording />} />

        <Route path="conversations/*" element={<ConversationsWrapper />}>
          <Route index element={<Conversations />} />
          <Route path=":id" element={<ConversationsShow />} />
          <Route path="popup/:id" element={<ConversationsShow />} />
        </Route>

        <Route path="analytics" element={<Analytics />} />
        <Route path="outcomes" element={<Outcomes />} />
        <Route path="lightningout" element={<LightningOut />} />
        <Route path="mobile_wysiwyg" element={<MobileWysiwyg />} />

        <Route path="conversations/*" element={<ConversationsWrapper />}>
          <Route index element={<Conversations />} />
          <Route path=":id" element={<ConversationsShow />} />
          <Route path="popup/:id" element={<ConversationsShow />} />
        </Route>

        <Route path="playbooks/*" element={<PlaysWrapper />}>
          <Route index element={<Plays />} />
          <Route path=":id" element={<PlaysShow />} />
          <Route
            path=":playbookid/plays/:playid/history"
            element={<PlaysHistory />}
          />
          <Route
            path=":playbookid/plays/:playid/history/:changeEventId"
            element={<PlaysHistoryDetails />}
          />
        </Route>

        <Route path="accounts" element={<Accounts />} />
        <Route path="scheduled_emails" element={<ScheduledEmails />} />
        <Route path="email_reminders" element={<EmailReminders />} />
        <Route path="people" element={<People />} />
        <Route path="settings" element={<Settings />} />

        <Route path="spaces/*" element={<SpacesWrapper />}>
          <Route index element={<Spaces />} />
          <Route path=":id" element={<SpacesShow />} />
        </Route>

        <Route path="coaching" element={<Coaching />} />
        <Route path="troubleshooting" element={<Troubleshooting />} />
        <Route path="error" element={<Error />} />
        <Route path="reconnect" element={<Reconnect />} />
        <Route
          path="refreshSalesforceMeta"
          element={<RefreshSalesforceMeta />}
        />

        <Route path="onboarding/*" element={<OnboardingWrapper />}>
          <Route index element={<OnboardingLanding />} />
          <Route path="steps" element={<OnboardingSteps />} />
          <Route
            path="microsoft_steps"
            element={<MicrosoftOnboardingSteps />}
          />
        </Route>

        <Route path="salesnavconnected" element={<Salesnavconnected />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};
